import { useMutation } from '@tanstack/react-query';
import qs from 'qs';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';
import { TakerMarket } from './useTakerMarkets';

export type PlayableInvoiceExclusionsRequestBody =
  paths['/playable-invoices/manage-exclusions']['post']['requestBody']['content']['application/json'];
export type PlayableInvoiceExclusionsResponse =
  paths['/playable-invoices/manage-exclusions']['post']['responses']['200']['content']['application/json'];
export type PlayableInvoiceExclusionsSearch = PlayableInvoiceExclusionsRequestBody['search'];

export interface PlayableInvoiceExclusionsParams {
  makerOrganizationUuid: string;
  exact?: { vouchers: string[] };
  includeStats?: boolean;
  mode?: 'NARROWING' | 'FOCUSING';
  operation?: 'EXCLUDE' | 'INCLUDE';
  overrides?: {
    include?: {
      vouchers: string[];
    };
    exclude?: {
      vouchers: string[];
    };
  };
  search?: PlayableInvoiceExclusionsSearch;
  takerMarkets: TakerMarket[];
}

export const usePlayableInvoiceExclusions = () => {
  return useMutation({
    mutationKey: ['playable-invoice-exclusions'],
    mutationFn: ({
      exact,
      includeStats = false,
      makerOrganizationUuid,
      mode,
      operation,
      overrides,
      search,
      takerMarkets,
    }: PlayableInvoiceExclusionsParams) => {
      const params = qs.stringify({ ...(includeStats && { includeStats: true }) }, { addQueryPrefix: true });

      return apiClient
        .post(`api/supplier-experience/playable-invoices/manage-exclusions${params}`, {
          json: {
            makerOrganizationUuid,
            supplierMarkets: takerMarkets.map((market) => ({
              marketUuid: market.marketUuid,
              supplierDivisionUuid: market.takerDivisionUuid,
            })),
            ...(exact ? { exact } : {}),
            ...(mode ? { mode } : {}),
            ...(operation ? { operation } : {}),
            ...(overrides ? { overrides } : {}),
            ...(search ? { search } : {}),
          } satisfies PlayableInvoiceExclusionsRequestBody,
        })
        .json<PlayableInvoiceExclusionsResponse>();
    },
  });
};
